<template src="./DeliveryDataDetailComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {ref, computed, reactive, onMounted, watch, nextTick} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useDeliveryStore} from "@/stores/delivery.js";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import {usePartnerStore} from "@/stores/partner.js";
import {AppConstant, AlertText} from "@/supports/app.constant";
import {ConfirmText, ErrorText} from "@/supports/error-message.constant";
import InputNumberComponent from "@/components/inputs/input-number/InputNumberComponent.vue";
import {useRoute, useRouter} from "vue-router";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import ModalDeliveryCommentComponent
  from "@/components/modals/modal-delivery-comment/ModalDeliveryCommentComponent.vue";
import IconComment from "@/components/icons/IconComment.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import {useUserStore} from "@/stores/users.js";
import AlertWarningComponent from "@/components/alerts/alert-warning/AlertWarningComponent.vue";
import ButtonRejectComponent from "@/components/buttons/button-reject/ButtonRejectComponent.vue";
import {useWarehouseStore} from "@/stores/warehouse.js";
import {useStore} from "@/stores/store.js";
export default {
  name: 'DeliveryDataDetailComponent',
  components: {
    ButtonRejectComponent,
    AlertWarningComponent,
    InputDateTimeNormal,
    IconComment,
    ModalDeliveryCommentComponent,
    InputCheckboxOne,
    InputNumberComponent,
    LoadingComponent,
    ModalDeliveryProductListComponent,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  setup() {
    const errors = ref(true)
    const dataExchangeDelivery = ref({
      partner_assignee: {
        id: 'partner_assignee',
        label: 'Người kiểm duyệt phiếu',
        placeholder: 'Người kiểm duyệt phiếu',
        value: '',
        error: '',
        isError: false,
        required: false,
        disabled: false,
        options: []
      },
      exchange_delivery_name: {
        id: 'exchange_delivery_name',
        label: 'Tên phiếu giao hàng',
        placeholder: 'Tên phiếu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        disabled: false,
      },
      partner_id: {
        id: 'partner_id',
        label: 'Đối tác giao hàng',
        placeholder: 'Đối tác giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false,
        options: []
      },
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      warehouse_id: {
        id: 'warehouse_id',
        label: 'Kho hàng',
        placeholder: 'Kho hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      delivery_id: {
        id: 'delivery_id',
        label: 'Dữ liệu giao hàng',
        placeholder: 'Dữ liệu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      exchange_delivery_description: {
        id: 'exchange_delivery_description',
        label: 'Mô tả phiếu giao hàng',
        placeholder: 'Mô tả phiếu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        disabled: false
      },
      delivery_date: {
        id: 'delivery_date',
        label: 'Ngày giao hàng',
        placeholder: 'Ngày giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        disabled: false,
      },
    })
    const dataHeaderTable = ref({
      sortRecord: {
        label: '#',
        order: 1,
        width: '2%',
      },
      product_name: {
        label: 'Tên sản phẩm',
        order: 2,
        width: '15%',
      },
      product_code: {
        label: 'Mã sản phẩm',
        order: 3,
        width: '10%',
      },
      product_price: {
        label: 'Giá sản phẩm',
        order: 4,
        width: '10%',
      },
      product_selling_price: {
        label: 'Giá bán',
        order: 5,
        width: '10%',
      },
      product_quantity: {
        label: 'Số lượng',
        order: 6,
        width: '10%',
      },
      product_tax: {
        label: 'Thuế (%)',
        order: 7,
        width: '10%',
      },
      product_unit: {
        label: 'Đơn vị',
        order: 8,
        width: '10%',
      },
      product_total_origin: {
        label: 'Giá chưa tính thuế',
        order: 9,
        width: '12.5%',
      },
      product_total: {
        label: 'Tổng tiền',
        order: 10,
        width: '12.5%',
      },
    })
    const labelSelectProduct = ref('Chọn sản phẩm')
    const eventClickShowModal = ref(false)
    const eventClickShowModalComment = ref(false)
    const isLoading = ref(false)
    const totalPrice = ref(0)
    const totalPriceWithTax = ref(0)
    const deliveryId = ref(0)
    const partnerId = ref(0)
    const partnerDelivery = ref(null)
    const delivery = ref({})
    const heightComment = ref('300px')
    const accountComment = ref({
      company_name: '',
      logo: '',
      user_name: '',
    })
    const listProductsSelected = ref([])
    const listProductIds = ref([])
    const listComments = ref([])
    const useToStoreDelivery = ref(false)
    const disabledStoreDelivery = ref(true)
    const disableFields = ref(false)
    const isReject = ref(false)
    const type = ref(1)
    const route = useRoute()
    const router = useRouter()
    const partnerStore = usePartnerStore()
    const deliveryStore = useDeliveryStore()
    const accountStore = useAccountStore()
    const userStore = useUserStore()
    const warehouseStore = useWarehouseStore()
    const storeCompStore = useStore()
    const stateModal = reactive({
      modalDeliveryProductList: null,
      modalDeliveryComment: null,
    })

    // set up modal and call api get list partner
    onMounted(() => {
      stateModal.modalDeliveryProductList = new bootstrap.Modal('#modaldeliveryProduct', {})
      stateModal.modalDeliveryComment = new bootstrap.Modal('#modalDeliveryComment', {})
      getListPartner();

      if(parseInt(route.query.type) === AppConstant.TAB_OWNER) {
        getListStores();
        getListWarehouses();
      }
      if(parseInt(route.query.type) === AppConstant.TAB_PARTNER) {
        type.value = AppConstant.TAB_PARTNER
        delete dataHeaderTable.value.product_price
        getListUsers();
      }
      getDeliveryDetail(route.query.id, route.query.type);
    })

    // listen change list partner
    const listPartners = computed(() => {
      return partnerStore.partners;
    });
    const users = computed(() => {
      return userStore.users;
    });

    watch(() => deliveryStore.delivery, (newDelivery) => {
      if (!newDelivery) {
        router.push({ name: '404'})
      }
      totalPrice.value = deliveryStore.delivery.sum_amount;
      totalPriceWithTax.value = deliveryStore.delivery.sum_tax_included;
      delivery.value = newDelivery
      dataExchangeDelivery.value.exchange_delivery_name.value = newDelivery.delivery_name
      dataExchangeDelivery.value.exchange_delivery_description.value = newDelivery.delivery_description
      dataExchangeDelivery.value.partner_id.value = newDelivery.m_company_receiver_id
      dataExchangeDelivery.value.delivery_date.value = newDelivery.delivery_date
      dataExchangeDelivery.value.partner_assignee.value = newDelivery.partner_assignee_id
      dataExchangeDelivery.value.delivery_id.value = newDelivery.m_delivery_id
      dataExchangeDelivery.value.warehouse_id.value = newDelivery.warehouse_id
      dataExchangeDelivery.value.store_id.value = newDelivery.store_id
      partnerId.value = dataExchangeDelivery.value.partner_id.value
      partnerDelivery.value = listPartners.value.find((partner) => parseInt(partner.partner_company_id) === parseInt(partnerId.value));
      listProductsSelected.value = newDelivery.deliveryDetails
      listProductsSelected.value.forEach((product) => {
        product.total_price_origin = product.product_selling_price * product.product_quantity;
        product.total_price_tax = (1 + parseInt(product.tax_rate)/100) * product.total_price_origin;
      });
      deliveryId.value = newDelivery.id
      listComments.value = newDelivery.comments
      if(parseInt(route.query.type) === AppConstant.TAB_PARTNER) {
        dataExchangeDelivery.value.exchange_delivery_name.disabled = true
        dataExchangeDelivery.value.exchange_delivery_description.disabled = true
        dataExchangeDelivery.value.partner_id.disabled = true
        dataExchangeDelivery.value.delivery_date.disabled = true
        disableFields.value = true
      }
      if(parseInt(delivery.value.status) === AppConstant.DELIVERY_STATUS_REJECT) {
        isReject.value = true
        dataExchangeDelivery.value.partner_id.disabled = true
      }
      console.log(dataExchangeDelivery.value.store_id.value, 11111)
    })

    watch(() => storeCompStore.stores, (newListStores) => {
      if(newListStores.length) {
        newListStores.forEach((item) => {
          dataExchangeDelivery.value.store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
    });

    watch(() => dataExchangeDelivery.value.store_id.value, (newStore) => {
      if(dataExchangeDelivery.value.delivery_id.value) {
        const listMasterDeliveriesStore = deliveryStore.masterDeliveries.filter((item) => {
          return item.store?.id === newStore
        })
        if(listMasterDeliveriesStore.length) {
          listMasterDeliveriesStore.forEach((masterDelivery) => {
            dataExchangeDelivery.value.delivery_id.options.push({
              name: masterDelivery.exchange_delivery_name,
              value: masterDelivery.id,
              detail: masterDelivery.delivery_detail,
            })
          })
        }
        const compareOdDelivery = dataExchangeDelivery.value.delivery_id.options.find((item) => {
          return item.value === dataExchangeDelivery.value.delivery_id.value;
        })
        if(!compareOdDelivery) {
          dataExchangeDelivery.value.delivery_id.value = ''
        }
        console.log(dataExchangeDelivery.value.store_id.value, 22222)
      }
    });

    // call api list partner
    async function getListPartner() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/partner/partner-list';
      await partnerStore.getListPartners(url, params);
      partnerStore.partners.forEach((partner) => {
        dataExchangeDelivery.value.partner_id.options.push({
          name: partner.partner_name,
          value: partner.partner_company_id
        })
      })
    }

    async function getListStores() {
      const params = {
        id: accountStore.account.company.id,
        type: 1
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }
    async function getListWarehouses() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/warehouse/list-warehouse';
      await warehouseStore.getListWarehouses(url, params);
      warehouseStore.warehouses.forEach((warehouse) => {
        dataExchangeDelivery.value.warehouse_id.options.push({
          name: warehouse.name,
          value: warehouse.id
        })
      })
    }

    async function getListUsers() {
      const params = {
        company_id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/users/user-list';
      await userStore.getListUser(url, params);
      userStore.users.forEach((user) => {
        dataExchangeDelivery.value.partner_assignee.options.push({
          name: user.user_name,
          value: user.id
        })
      })
    }

    async function getDeliveryDetail(id, type) {
      const params = {
        id: accountStore.account.company.id,
        delivery_id: id,
        type: type
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/delivery-detail';
      await deliveryStore.getDeliveryDetail(url, params);
    }

    // create delivery
    async function createDelivery() {
      for (const item in dataExchangeDelivery.value) {
        validateForm(dataExchangeDelivery.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        listProducts.value.forEach((product) => {
          product.tax_rate = product.product_tax
          delete product.id;
        })
        const params = {
          m_company_id: accountStore.account.company.id,
          m_user_created_id: CommonService.getUserId(),
          delivery_name: dataExchangeDelivery.value.exchange_delivery_name.value,
          m_company_receiver_id: dataExchangeDelivery.value.partner_id.value,
          delivery_description: dataExchangeDelivery.value.exchange_delivery_description.value,
          deliveryDetails: listProducts.value,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/create';
        const product = await deliveryStore.createDeliveries(url, params);
        await CommonService.showAlertPopup({
          title: product?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });
      }
    }
    function onChange(value, name) {
      dataExchangeDelivery.value[name].value = value
    }
    function validateForm(value, name) {
      if(name === 'exchange_delivery_name') {
        dataExchangeDelivery.value.exchange_delivery_name.isError = false;
        dataExchangeDelivery.value.exchange_delivery_name.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.exchange_delivery_name.isError = true;
          dataExchangeDelivery.value.exchange_delivery_name.error = ErrorText.REQUIRED(dataExchangeDelivery.value.exchange_delivery_name.label);
          errors.value = true
        }
      }
      if(name === 'partner_id') {
        dataExchangeDelivery.value.partner_id.isError = false;
        dataExchangeDelivery.value.partner_id.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.partner_id.isError = true;
          dataExchangeDelivery.value.partner_id.error = ErrorText.REQUIRED(dataExchangeDelivery.value.partner_id.label);
          errors.value = true
        }
      }
      if(name === 'warehouse_id') {
        dataExchangeDelivery.value.warehouse_id.isError = false;
        dataExchangeDelivery.value.warehouse_id.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.warehouse_id.isError = true;
          dataExchangeDelivery.value.warehouse_id.error = ErrorText.REQUIRED(dataExchangeDelivery.value.warehouse_id.label);
          errors.value = true
        }
      }
      if(name === 'store_id') {
        dataExchangeDelivery.value.store_id.isError = false;
        dataExchangeDelivery.value.store_id.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.store_id.isError = true;
          dataExchangeDelivery.value.store_id.error = ErrorText.REQUIRED(dataExchangeDelivery.value.store_id.label);
          errors.value = true
        }
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function onChangeProductQuantity(value, name) {
      const productId = name.split('_')[1]
      totalPrice.value = 0
      totalPriceWithTax.value = 0;
      listProductsSelected.value.forEach((product) => {
        if(parseInt(productId) === parseInt(product.id)) {
          product.error_empty_quantity = !value && value !== false;
          if(!product.error_empty_quantity) {
            product.product_quantity = isNaN(parseFloat(value)) ? 0 : value
            product.total_price_origin = product.product_price * product.product_quantity;
            product.total_price_tax = (1 + parseInt(product.tax_rate)/100) * product.total_price_origin;
          }
        }
        if(!product.error_empty_quantity) {
          const amount = product.product_price * product.product_quantity;
          const fee = product.product_price * product.product_quantity * (product.tax_rate / 100);
          totalPrice.value += amount;
          totalPriceWithTax.value += (amount + fee);
        }
      });
    }

    function onChangeProductSellingPrice(value, name) {
      totalPrice.value = 0
      totalPriceWithTax.value = 0;
      let product_price_current = 0;
      const productId = name.split('_')[1]
      listProductsSelected.value.forEach((product) => {
        if(parseInt(productId) === parseInt(product.id)) {
          product.error_selling = !value && value !== false;
          if(!product.error_selling) {
            product_price_current = value > 0 ? value : product.product_price;
            product.product_selling_price = product_price_current;
            product.total_price_origin = product_price_current * product.product_quantity;
            product.total_price_tax = (1 + parseInt(product.tax_rate)/100) * product.total_price_origin;
          }
        }
        if(!product.error_selling) {
          const amount = product_price_current * product.product_quantity;
          const fee = product_price_current * product.product_quantity * (product.tax_rate / 100);
          totalPrice.value += amount;
          totalPriceWithTax.value += (amount + fee);
        }
      });
    }

    function onChangeStoreDelivery(value) {
      useToStoreDelivery.value = value
    }

    function removeProduct(productId, productName) {
      CommonService.showAlertPopup({
        title: ConfirmText.CONFIRM_REMOVE(productName),
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        timer: undefined,
        width: '800px'
      }).then((result) => {
        if (result.isConfirmed) {
          listProductsSelected.value = listProductsSelected.value.filter((product) => parseInt(product.id) !== productId)
          totalPrice.value = 0
          listProductsSelected.value.forEach((product) => {
            product.total_price_origin = product.product_price * product.product_quantity_set;
            product.total_price_tax = (1 + parseInt(product.product_tax)/100) * product.total_price_origin;
            const amount = product.product_price * product.product_quantity_set;
            const fee = product.product_price * product.product_quantity_set * (product.product_tax / 100);
            totalPrice.value += (amount + fee);
          });
          checkProductsWithMaster(listProductsSelected.value)
        }
      });
    }

    function checkProductsWithMaster(listProductsCurrent) {
      disabledStoreDelivery.value = true
      if(listProductsCurrent.length !== listProductIds.value.length) {
        disabledStoreDelivery.value = false
      }
      if(listProductsCurrent.length === listProductIds.value.length) {
        listProductsCurrent.forEach((product) => {
          if(!listProductIds.value.includes(product.id)) {
            disabledStoreDelivery.value = false
          }
        })
      }
    }

    function showModalProductList() {
      eventClickShowModal.value = true
      isLoading.value = true
    }

    function showModalProduct(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModal.value = false
          isLoading.value = false
          stateModal.modalDeliveryProductList.show()
        }, 1000);
        return;
      }
      stateModal.modalDeliveryProductList.hide()
    }

    function eventSearchProduct(isSearch) {
      if(!eventClickShowModal.value) {
        isLoading.value = isSearch
      }
    }

    function eventGetListProductsSelected(listProductsSelectedCurrent) {
      listProductsSelected.value = listProductsSelectedCurrent
      listProductsSelected.value.forEach((product) => {
        product.tax_rate = product.product_tax;
        product.product_selling_price = product.product_price;
        product.product_quantity_set = 0;
      })
      checkProductsWithMaster(listProductsSelected.value)
    }

    function clickShowModalComment() {
      accountComment.value.company_name = accountStore.account.company.company_name ?? '';
      accountComment.value.user_name = accountStore.account.username;
      eventClickShowModalComment.value = true
    }

    function showModalComment(isShow) {
      if(isShow) {
        stateModal.modalDeliveryComment.show()
      }
      stateModal.modalDeliveryComment.hide()
    }

    function showNewComment(comment) {
      listComments.value.unshift(comment)
    }

    async function approveUser() {
      validateApproveUser()
      if(checkSubmitActive.value) {
        const params = {
          company_id: parseInt(accountStore.account.company.id),
          user_id: dataExchangeDelivery.value.partner_assignee.value,
          delivery_id: deliveryId.value,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/approve-user-delivery';
        const approveUser = await deliveryStore.approveUserDelivery(url, params);
        await CommonService.showAlertPopup({
          title: approveUser?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });
        deliveryStore.deliveries.partner_assignee_id = dataExchangeDelivery.value.partner_assignee.value
      }
    }

    function validateApproveUser() {
      dataExchangeDelivery.value.partner_assignee.isError = false;
      dataExchangeDelivery.value.partner_assignee.error = ''
      errors.value = false
      if(!dataExchangeDelivery.value.partner_assignee.value) {
        dataExchangeDelivery.value.partner_assignee.isError = true;
        dataExchangeDelivery.value.partner_assignee.error = ErrorText.REQUIRED(dataExchangeDelivery.value.partner_assignee.label);
        errors.value = true
      }
    }

    async function rejectDelivery() {
      const params = {
        company_id: parseInt(accountStore.account.company.id),
        partner_id: delivery.value.m_company_created_id,
        delivery_id: deliveryId.value
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/reject';
      const approveUser = await deliveryStore.rejectDelivery(url, params);
      await CommonService.showAlertPopup({
        title: approveUser?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1000,
        width: '800px'
      });
      isReject.value = true
    }
    function approvedDelivery() {
      // const params = {
      //   company_id: parseInt(accountStore.account.company.id),
      //   partner_id: delivery.value.m_company_created_id,
      //   delivery_id: deliveryId.value
      // }
      // const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/reject';
      // const approveUser = await deliveryStore.rejectDelivery(url, params);
      // await CommonService.showAlertPopup({
      //   title: approveUser?.message,
      //   icon: "success",
      //   showConfirmButton: false,
      //   timer: 1000,
      //   width: '800px'
      // });
      // isReject.value = true
    }

    async function updateDelivery() {
      for (const item in dataExchangeDelivery.value) {
        validateForm(dataExchangeDelivery.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        let productIds = []
        listProductsSelected.value.forEach((product) => {
          productIds.push(product.id)
          delete product.total_price_origin;
          delete product.total_price_tax;
          delete product.error_empty_quantity;
          delete product.error_selling;
        })
        const params = {
          m_company_id: accountStore.account.company.id,
          delivery_id: deliveryId.value,
          m_user_created_id: CommonService.getUserId(),
          delivery_name: dataExchangeDelivery.value.exchange_delivery_name.value,
          delivery_description: dataExchangeDelivery.value.exchange_delivery_description.value,
          delivery_date: dataExchangeDelivery.value.delivery_date.value,
          deliveryDetails: listProductsSelected.value,
          useToStoreDelivery: useToStoreDelivery.value,
          productIds: productIds
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/update';
        const product = await deliveryStore.createDeliveries(url, params);
        await CommonService.showAlertPopup({
          title: product?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });
      }
    }

    return {
      delivery,
      deliveryId,
      partnerId,
      totalPrice,
      dataExchangeDelivery,
      labelSelectProduct,
      dataHeaderTable,
      deliveryStore,
      isLoading,
      eventClickShowModal,
      checkSubmitActive,
      errors,
      listProductsSelected,
      useToStoreDelivery,
      disabledStoreDelivery,
      listComments,
      heightComment,
      eventClickShowModalComment,
      accountComment,
      disableFields,
      isReject,
      totalPriceWithTax,
      type,
      partnerDelivery,
      AppConstant,
      CommonService,
      AlertText,
      onChange,
      validateForm,
      createDelivery,
      onChangeProductQuantity,
      onChangeProductSellingPrice,
      showModalProductList,
      showModalProduct,
      eventSearchProduct,
      eventGetListProductsSelected,
      onChangeStoreDelivery,
      removeProduct,
      clickShowModalComment,
      showModalComment,
      showNewComment,
      approveUser,
      rejectDelivery,
      approvedDelivery,
      updateDelivery
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
        .comments {
          border-radius: 10px;
          border: 1px solid #d9dee3;
          overflow-y: scroll;
          ::-webkit-scrollbar {
            width: 10px;
          }
          ::-webkit-scrollbar-track {
            background: #f1f1f1;
          }
          ::-webkit-scrollbar-thumb {
            background: #888;
          }
          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          .no_comments {
            height: 80%;
          }
          .create_comment {
            height: 20%;
          }
          .list_comments {
            .comment {
              .info {
                .name {
                  .company, .user {
                    border: 1px solid #000;
                    border-radius: 20px;
                    padding: 5px 10px
                  }
                }
              }
              .content {
                padding: 10px;
              }
            }
            .part {
              border-top: 1px solid #000;
              margin: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
